
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CustomFieldGridValueUnion": [
      "CustomCurrencyFieldGrid",
      "CustomDatetimeFieldGrid",
      "CustomEmployeeFieldGrid",
      "CustomFullDateTimeFieldGrid",
      "CustomMultiCompanyFieldGrid",
      "CustomMultiContactFieldGrid",
      "CustomMultiCountryFieldGrid",
      "CustomMultiEmployeeFieldGrid",
      "CustomMultiOptionalValueFieldGrid",
      "CustomNewlyDefinedFieldGrid",
      "CustomNumberFieldGrid",
      "CustomOptionalValueFieldGrid",
      "CustomRichTextFieldGrid",
      "CustomTextFieldGrid"
    ],
    "CustomFieldValue": [
      "CustomFieldCompany",
      "CustomFieldContact",
      "CustomFieldDate",
      "CustomFieldEmployee",
      "CustomFieldFullDateTime",
      "CustomFieldMoney",
      "CustomFieldMulti",
      "CustomFieldMultiCountry",
      "CustomFieldMultiEmployee",
      "CustomFieldNumber",
      "CustomFieldOptional",
      "CustomFieldRichText",
      "CustomFieldString",
      "CustomFieldTimeRange"
    ],
    "FormElement": [
      "InputElement",
      "TextElement"
    ],
    "PageResult": [
      "BlockPageList",
      "Campaign",
      "CompanyListItem",
      "EmbedUrl",
      "GenericList",
      "KeyActivityList",
      "List",
      "SaveView"
    ],
    "WorkflowRecipient": [
      "Campaign",
      "List"
    ]
  }
};
      export default result;
    